import { render, staticRenderFns } from "./ReceptionMonitor.vue?vue&type=template&id=0fa23e66&"
import script from "./ReceptionMonitor.vue?vue&type=script&lang=js&"
export * from "./ReceptionMonitor.vue?vue&type=script&lang=js&"
import style0 from "./ReceptionMonitor.vue?vue&type=style&index=0&id=0fa23e66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports